<template>
  <layout-report-step :isDone="isDone" :title="header.title" :description="header.description" :debug="damageLocation">
    <v-card flat max-width="500" class="pt-4">
      <form>
        <div class="center">
          <damage-locator-truck
            v-on:svgClicked="svgClicked"
            :damage-locations="damageLocation"
            :clickedColor="color"
            :readOnly="false"
          />
        </div>
      </form>

      <v-card-text class="pb-0">
        <transition name="fade">
          <p class="pb-0 mb-0" v-if="!isDone">{{ $t("report.damageLocator.locateDamage") }}</p>
        </transition>
      </v-card-text>
      <Debug :debug="damageLocation"></Debug>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import DamageLocatorTruck, { SvgPathClickObject } from "@/components/damagelocator/DamageLocatorTruck.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";
import Debug from "@/components/utility/Debug.vue";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { ReportType } from "@/store/enum/reportType";

@Component({
  components: {
    LayoutReportStep,
    DamageLocatorTruck,
    Debug
  }
})
export default class ReportDamageLocationTruck extends ReportStepMixin implements IReportStep {
  instruction?: IReportInstructionData | undefined;
  header: IReportHeaderData = {
    title: "report.damageLocator.title",
    description: "report.damageLocator.description"
  };

  damageLocation: string[] = ReportModule.inCreationReport.damageLocation;

  screen = ReportScreenEnum.damagelocatortruck;

  get isDone() {
    return this.damageLocation.length >= 1;
  }

  mounted() {
    ReportModule.setReportType(ReportType.TRUCK);
  }

  svgClicked(e: any) {
    if (!e) return;

    const clickedObject: SvgPathClickObject = {
      mapId: e.mapId,
      title: e.title
    };

    if (this.damageLocation && this.damageLocation.includes(clickedObject.title)) {
      ReportModule.popDamageLocation(clickedObject.title);
    } else {
      ReportModule.pushDamageLocation(clickedObject.title);
    }
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
